module.exports = __webpack_public_path__ + "img/默认logo 360@1x.65bca139.png";